import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, ImageAvatar, SquareChip, Text, useSettings, Utils } from 'app/main/components';
import { ViewList } from 'app/main/components/page-layouts';
import { DateSquareChip } from 'app/main/components/list-items';

function OpenDemListItem(props: ItemLayoutProps) {
	const openInNew = () => Utils.openLink({ pathname: `/dems/details/${props.model.dems_uid}`, newTab: true });

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.dems_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.dems_title_initials}
		/>
	);

	return (
		<GridListItem
			avatar={avatar}
			secondaryAction={
				<IconButton onClick={openInNew}>
					<Icon icon="open-in-new" />
				</IconButton>
			}
		>
			<Grid container>
				{/* TITLE */}
				<Grid size={12}>
					<Text variant="subtitle2" className="font-600">
						{props.model.dems_title}
					</Text>
				</Grid>
				{/* LAST SYNC DATE */}
				<Grid>
					<DateSquareChip
						value={props.model.dems_d_sync}
						format={{ year: 'numeric', month: '2-digit', day: '2-digit' }}
					/>
				</Grid>
				{/* STATUS */}
				<Grid>{props.model.dmst_title && <SquareChip label={props.model.dmst_title} />}</Grid>
			</Grid>
		</GridListItem>
	);
}

export const showOpenDemsAlertDialog = () => openDialog({ children: <OpenDemsAlertDialog /> });

export default function OpenDemsAlertDialog() {
	const dispatch = useDispatch();
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>
				{t('DIALOG_OPEN_DEMS_TITLE')}
				<Typography>{t('DIALOG_OPEN_DEMS_CONTENT')}</Typography>
			</DialogTitle>
			<DialogContent className="p-0">
				<ViewList
					module="dems"
					itemLayout={OpenDemListItem}
					defaultFilters={[
						{
							filt_field: 'dems_deleted',
							filt_clause: 'not_equal',
							filt_value: 1
						},
						{
							filt_field: 'dems_connector',
							filt_clause: 'equals',
							filt_value: 'mailchimp'
						},
						{
							filt_field: 'dems_dmst_id',
							filt_clause: 'in',
							filt_value: [2, 3, 4]
						}
					]}
					showExportButton={false}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CLOSE')}</Button>
			</DialogActions>
		</>
	);
}
